/* eslint-disable react-hooks/exhaustive-deps */
import React, {useMemo, useRef, useEffect} from 'react';
import * as THREE from "three";

import { const_var, params } from '../../../../../redux/reducers/reducer';
import { extrudeSettings, railModel } from '../../../../../utils/Functions';
import BaseRailModel from '../../BaseRail';
import PillarRailModel from '../../Legs';
import CommonTruss from '../CommonTruss';
import { MaterialTruss } from '../../../CustomMaterial';
import { trussDimensions } from '../../../../../helpers/building_component/truss/truss.helper';

const hangRailDivision = 1 / 2;

const TWCT = ({ trussType, normalMap, envMap, trussModelPosInfoArr, overlapTrussArr, hiddenBaseRailIdArr, meshDelModel_CSG, isFor  }) => {

    return (
        <>
            {isFor === 'center' && <BaseRailModel normalMap={normalMap} envMap={envMap} meshDelModel_CSG={meshDelModel_CSG} />}
            {isFor === 'center' && <PillarRailModel trussType={trussType} trussModelPosInfoArr={trussModelPosInfoArr} normalMap={normalMap} envMap={envMap} meshDelModel_CSG={meshDelModel_CSG} overlapTrussArr={overlapTrussArr} hiddenBaseRailIdArr={hiddenBaseRailIdArr} hangRailDivision={hangRailDivision} />}
            <TrussModel trussType={trussType} trussModelPosInfoArr={trussModelPosInfoArr} normalMap={normalMap} envMap={envMap} meshDelModel_CSG={meshDelModel_CSG} overlapTrussArr={overlapTrussArr} hiddenBaseRailIdArr={hiddenBaseRailIdArr} isFor={isFor} />
        </>
    )
}

export default TWCT

const TrussModel = ({ trussType, trussModelPosInfoArr, normalMap, envMap, overlapTrussArr, hiddenBaseRailIdArr, isFor }) => {   
    const obj_rungHRail = new THREE.Object3D();
    const obj_centerVRail = new THREE.Object3D();

    const ref_rungHRail = useRef();
    const ref_centerVRail = useRef();
    
    const connectRailWidth = 0.3;
    const connectRailHeight = 0.2;
    const offset = 0.035;
    const trussDimension = trussDimensions(isFor)
    const rung_width = (trussType === "RBCAT") ? 16 : 22

    const alignPosOffset = useMemo(() => {
        if(params.p_r_s === 1 ) return const_var.roofRegularDst * 2;
        else if(params.p_r_s === 2 || params.p_r_s === 3) return 0;
        else return 0;
    }, [params.p_r_s, trussDimension.roofPitch])

    const roofTrussData = useMemo(() => {
        const rungTrussHeight = (( trussDimension.buildingWidth / 2 ) * trussDimension.roofPitch / 12) * hangRailDivision - connectRailHeight / 2;
        const rung_x = (trussType === "RBCAT" || trussType === "RBCBT") ? -rung_width/2 : -trussDimension.buildingWidth / 2 * hangRailDivision;
        const rung_y = (trussType === "RBCAT" || trussType === "RBCBT") ? trussDimension.buildingHeight + (trussDimension.buildingWidth/2 * (trussDimension.roofPitch / 12)) - (rung_width/2 * (trussDimension.roofPitch / 12)) - connectRailHeight / 2 : trussDimension.buildingHeight + rungTrussHeight;
        const braceTrussHight = (trussDimension.buildingWidth / 32 * 3 + trussDimension.buildingWidth / 64) * (trussDimension.roofPitch / 12);
        const braceTrussLength = Math.sqrt(Math.pow(braceTrussHight, 2) + Math.pow((trussDimension.buildingWidth / 64 * 3), 2));
        const braceTrussAngle = Math.acos((trussDimension.buildingWidth * 3) / (64 * braceTrussLength))
        const brace_x = trussDimension.buildingWidth / 32 * 3 - connectRailHeight / 2;
        const brace_y = trussDimension.buildingHeight + rungTrussHeight;
        
        return {
            rung: {
                pos_x: rung_x,
                pos_y: rung_y,
            },
            brace: {
                alpha: braceTrussAngle,
                length: braceTrussLength,
                pos_x: brace_x,
                pos_y: brace_y,
            }
        }
    }, [trussType,trussDimension.buildingWidth, trussDimension.buildingHeight, trussDimension.roofPitch])

    const centerVRailLength = useMemo(() => {
        return (((( trussDimension.buildingWidth / 2 ) * trussDimension.roofPitch / 12) / 2 + 2 * connectRailWidth) / 3) / (Math.PI / 4);
    }, [trussDimension.roofPitch, trussDimension.buildingWidth])
    

    useEffect(() => {
        if (ref_rungHRail.current && ref_centerVRail.current) {
            let index_all = 0;
            new Array(2).fill('').forEach((_, index_dir) => {
                let offsetForDir = 1;
                if (index_dir === 0) offsetForDir = 1;
                else offsetForDir = -1
                
                new Array(trussModelPosInfoArr.length).fill('').forEach((_, index_truss) => {                        
                    //----- rung truss-----
                    obj_rungHRail.position.set(roofTrussData.rung.pos_x, roofTrussData.rung.pos_y - 0.025 + alignPosOffset, trussModelPosInfoArr[index_truss]);
                    obj_rungHRail.rotation.y = Math.PI / 2;

                    
                    //---------------------

                    //----- roof center rail-----
                    let posX = offsetForDir * trussDimension.buildingWidth / 8
                    if (trussType === "RBCAT" || trussType === "RBCBT") posX = (rung_width / 6) * offsetForDir
                    obj_centerVRail.position.set(posX, roofTrussData.rung.pos_y - 0.025 + alignPosOffset, trussModelPosInfoArr[index_truss]);
                    obj_centerVRail.rotation.x = -Math.PI / 2;
                    if (trussType === "TWCT") obj_centerVRail.rotation.y = offsetForDir * Math.PI / 4;

                    if (hiddenBaseRailIdArr.includes(index_truss)){
                        obj_rungHRail.scale.setScalar(0);
                        obj_centerVRail.scale.setScalar(0);
                    }else {
                        obj_rungHRail.scale.setScalar(1);
                        obj_centerVRail.scale.setScalar(1);
                    };

                    obj_rungHRail.updateMatrix();
                    ref_rungHRail.current.setMatrixAt(index_all, obj_rungHRail.matrix);
                    obj_centerVRail.updateMatrix();
                    ref_centerVRail.current.setMatrixAt(index_all, obj_centerVRail.matrix);

                    //---------------------

                    index_all ++;
                })
            })
            
            
            ref_rungHRail.current.instanceMatrix.needsUpdate = true;
            ref_centerVRail.current.instanceMatrix.needsUpdate = true;
        }
    }, [trussType,ref_rungHRail.current, ref_centerVRail.current, trussModelPosInfoArr, hiddenBaseRailIdArr, trussDimension.buildingHeight, trussDimension.roofPitch, trussDimension.buildingWidth, params.p_r_s])

    return (
        <group position={[0, -offset, 0]} rotation={[0,trussDimension.trussRotation,0]} name='TWCT-truss-legs'>
             <CommonTruss trussType={trussType} trussModelPosInfoArr={trussModelPosInfoArr} overlapTrussArr={overlapTrussArr} normalMap={normalMap} envMap={envMap} isFor={isFor}/>
            <>
                {/* --- roof center rail model --- */}
                    <instancedMesh ref={ref_centerVRail} args={[null, null, trussModelPosInfoArr.length * 2]} frustumCulled={false}>
                        <extrudeGeometry args={[railModel(connectRailHeight, connectRailWidth), extrudeSettings((trussType === "RBCAT" || trussType === "RBCBT") ? ((rung_width/3) * (trussDimension.roofPitch/12)) : centerVRailLength)]} />
                        <MaterialTruss normalMap={normalMap} envMap={envMap} />
                    </instancedMesh>
                {/* ------------------------- */}

                {/* --- rung truss model --- */}
                <instancedMesh ref={ref_rungHRail} args={[null, null, trussModelPosInfoArr.length]} frustumCulled={false}>
                    <extrudeGeometry args={[railModel(connectRailWidth, connectRailHeight), extrudeSettings((trussType === "RBCAT" || trussType === "RBCBT") ? rung_width : trussDimension.buildingWidth / 2)]} />
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </instancedMesh>
                {/* ------------------------- */}

            </>
    </group>
    )
}